import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    borderRadius: theme.borderRadii.sm,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    shadowColor: theme.colors.black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },
  text: {
    color: '#3a3a3a',
    textAlign: 'center',
    verticalAlign: 'auto',
  },
  wrongBg: {
    backgroundColor: theme.colors.red,
  },
  lightColor: {
    color: theme.colors.lightGrey,
  },
  correctBg: {
    backgroundColor: theme.colors.primary,
  },
  hidden: {
    opacity: 0,
  },
  fontAbz: {
    fontFamily: 'ABeeZeeRegular',
  },
  choicesWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
});
